import type { PropsWithChildren, ReactNode } from "react";
import { createContext, useContext } from "react";
import { CellMeasurerCache } from "react-virtualized";

export interface IVirtualizedListData {
  cache: CellMeasurerCache;
}

const defaultContextData: IVirtualizedListData = {
  cache: new CellMeasurerCache({
    fixedWidth: true,
    defaultHeight: 70,
  }),
};

const VirtualizedListContext = createContext(defaultContextData);

interface SearchProviderProps extends PropsWithChildren {}

export function VirtualizedListProvider({ children }: Readonly<SearchProviderProps>): ReactNode {
  return (
    <VirtualizedListContext.Provider value={defaultContextData}>
      {children}
    </VirtualizedListContext.Provider>
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export function useVirtualizedList(): IVirtualizedListData {
  const context = useContext(VirtualizedListContext);

  if (context == null) {
    throw new Error("useSearch must be used within a SearchProvider");
  }

  return context;
}
